import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import anime from 'animejs/lib/anime.min.js'

Vue.config.productionTip = false
Vue.prototype.$anime = anime

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
